<h1 mat-dialog-title>Sync</h1>
<div mat-dialog-content>
  <p>Your and online status are in different inning. Are you sure to sync to online status?</p>
  <div [class.half-scale]="isMobile$ |async">
    <app-status [broadcast]="broadcast" [preview]="true"></app-status>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close()">Close</button>
  <button mat-button (click)="confirm()" cdkFocusInitial>Confirm</button>
</div>
